import React, { Component } from 'react';
import accounting from 'accounting';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
  Table,
  Label,
  Alert,
} from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class AddIncentiveModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      error: null,
      adjustment: null,
    };
  }

  handleChange(field) {
    return (e) => {
      const value = e.target.value;
      this.setState({ [field]: value });
    };
  }

  addIncentive() {
    const { t } = this.props;
    return (e) => {
      const adjustment = {
        value: this.state.adjustmentValue,
        message: t('INCENTIVE_PAYMENT'),
        type: 'incentive_payment',
        category: 'incentive_payments',
      };

      if (!adjustment.value) {
        return this.setState({ error: t('ADJUSTMENT_AMOUNT_FIELD_ERROR') });
      }

      this.props.addIncentive(adjustment);
      this.props.onHide();
    };
  }

  renderInput() {
    return (
      <FormGroup>
        <ControlLabel>$ &nbsp;</ControlLabel>
        <FormControl
          type="number"
          onChange={this.handleChange('adjustmentValue')}
        />
      </FormGroup>
    );
  }

  renderError() {
    if (!this.state.error) {
      return '';
    }
    return <Alert bsStyle="warning">{this.state.error}</Alert>;
  }

  renderIncentiveFlow() {
    const { t } = this.props;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="lead">{t('AMOUNT_TO_ADD_TO_SHIPMENT')} </p>
            <div className="form-inline">{this.renderInput()}</div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={this.props.onHide} enforceFocus={false}>
        <Modal.Body>
          {this.renderError()}
          {this.renderIncentiveFlow()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>{titleize(t('CLOSE'))}</Button>
          <Button bsStyle="primary" onClick={this.addIncentive()}>
            {titleize(t('SAVE'))}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(AddIncentiveModal);
